import { FC, useMemo } from "react";
import Img from "components/base/img/Img";
import { AssetsDirectory } from "@finbackoffice/enums";
import { useSportFeedType } from "hooks";
import styles from "./team-icon.module.sass";
import { SportTypesBC, SportTypes } from "@finbackoffice/fe-core";
import { useRuntimeConfig } from "@finbackoffice/site-core";

interface IProps {
    sportId: number;
    teamId: number | undefined;
    priority?: boolean;
}

const TeamIcon: FC<IProps> = ({ sportId, teamId, priority = false }) => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    const { isBCFeed } = useSportFeedType();

    const iconsDirectory = isBCFeed ? AssetsDirectory.BCFeed : AssetsDirectory.BRFeed;

    const supportedSportIds = useMemo(
        () =>
            isBCFeed
                ? [
                      SportTypesBC.SOCCER,
                      SportTypesBC.BASKETBALL,
                      SportTypesBC.BASEBALL,
                      SportTypesBC.ICE_HOCKEY,
                      SportTypesBC.HANDBALL,
                      SportTypesBC.RUGBY_UNION,
                      SportTypesBC.RUGBY_LEAGUE,
                      SportTypesBC.RUGBY_SEVENS,
                      SportTypesBC.AUSSIE_RULES,
                      SportTypesBC.AMERICAN_FOOTBALL,
                      SportTypesBC.VOLLEYBALL,
                      SportTypesBC.FIELD_HOCKEY,
                      SportTypesBC.COUNTER_STRIKE,
                      SportTypesBC.DOTA_2,
                      SportTypesBC.CALL_OF_DUTY,
                      SportTypesBC.LEAGUE_OF_LEGENDS,
                      SportTypesBC.OVERWATCH,
                      SportTypesBC.CRICKET,
                      SportTypesBC.MOBILE_LEGENDS,
                      SportTypesBC.CROSSFIRE,
                      SportTypesBC.ESPORT_VALORANT,
                  ]
                : [
                      SportTypes.SOCCER,
                      SportTypes.BASKETBALL,
                      SportTypes.BASEBALL,
                      SportTypes.ICE_HOCKEY,
                      SportTypes.HANDBALL,
                      SportTypes.RUGBY,
                      SportTypes.AUSSIE_RULES,
                      SportTypes.AMERICAN_FOOTBALL,
                      SportTypes.VOLLEYBALL,
                      SportTypes.FIELD_HOCKEY,
                      SportTypes.COUNTER_STRIKE,
                      SportTypes.DOTA_2,
                      SportTypes.CALL_OF_DUTY,
                      SportTypes.LEAGUE_OF_LEGENDS,
                      SportTypes.OVERWATCH,
                      SportTypes.CRICKET,
                  ],
        [isBCFeed],
    );

    const fallbackSrc = `/${AssetsDirectory.Common}/${iconsDirectory}/${AssetsDirectory.TeamIcons}/${AssetsDirectory.Defaults}/${sportId}.webp`;

    const imgSource = useMemo(
        () =>
            supportedSportIds.includes(sportId)
                ? `/${AssetsDirectory.Common}/${iconsDirectory}/${AssetsDirectory.TeamIcons}/${sportId}/${teamId}.webp`
                : fallbackSrc,
        [fallbackSrc, iconsDirectory, sportId, supportedSportIds, teamId],
    );

    return (
        <Img
            source={imgSource}
            wrapperClassName={styles.teamIcon}
            width={0}
            height={0}
            style={{ width: "auto", height: "100%" }}
            alt="Team icon"
            priority={priority}
            fallbackSrc={`${ASSETS_URL}${fallbackSrc}`}
        />
    );
};

export default TeamIcon;
